import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import LabelDialog from './LabelDialog';
import { printShippingLabel } from '../../../reducers/requests';
import { closeShippingLabel, fetchSpecificPatientsOnly } from '../../../reducers/patients';
import { COMMON_PATIENT_INCLUDES } from '../../../constants/queries';
import ShippingLabel from '../Labels/ShippingLabel';
import getShipment from '../../../pages/PatientsPage/helpers/shipment';

const ShippingLabelDialog = ({ patients, close, markingAsPrinted, markPrinted }) => {
  const location = patients !== null ? getShipment(patients[0])?.location || null : null;
  const allPrinted = location && patients.every(patient => patient.shipping_label_printed === true);

  return (
    <LabelDialog
      open={location !== null}
      onClose={close}
      title="Print Shipping Label"
      printed={allPrinted}
      markingAsPrinted={markingAsPrinted}
      onPrinted={() => markPrinted(patients)}
      labels={{ printButton: 'Continue' }}
    >
      {location !== null && <ShippingLabel location={location} />}
    </LabelDialog>
  );
};

ShippingLabelDialog.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  patients: PropTypes.array,
  close: PropTypes.func.isRequired,
  markingAsPrinted: PropTypes.bool.isRequired,
  markPrinted: PropTypes.func.isRequired
};

ShippingLabelDialog.defaultProps = {
  patients: null
};

export default connect(
  state => {
    return {
      patients: state.patients.selection.shippingLabel,
      markingAsPrinted: state.requests.actions.markingShippingLabelInBulk
    };
  },
  dispatch => {
    return {
      markPrinted: patients => {
        const bundledShipmentId = patients[0].bundled_shipment_id;
        const patientIds = patients.map(patient => patient.id);
        dispatch(printShippingLabel(bundledShipmentId)).then(() => {
          dispatch(fetchSpecificPatientsOnly(patientIds, COMMON_PATIENT_INCLUDES));
          dispatch(closeShippingLabel());
        });
      },
      close: () => dispatch(closeShippingLabel())
    };
  }
)(ShippingLabelDialog);
